import * as React from "react";
const IconUploadV2 = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.4639 9.01106C18.4714 9.01102 18.4788 9.01101 18.4863 9.01101C20.9716 9.01101 22.9863 11.0294 22.9863 13.5193C22.9863 15.8398 21.2363 17.7508 18.9863 18M18.4639 9.01106C18.4787 8.84606 18.4863 8.67896 18.4863 8.51009C18.4863 5.46695 16.0239 3 12.9863 3C10.1096 3 7.74866 5.21267 7.50675 8.03192M18.4639 9.01106C18.3617 10.1476 17.9149 11.1846 17.2292 12.0165M7.50675 8.03192C4.97031 8.27373 2.98633 10.4139 2.98633 13.0183C2.98633 15.4417 4.70409 17.4632 6.98633 17.9273M7.50675 8.03192C7.66459 8.01687 7.82456 8.00917 7.98633 8.00917C9.11215 8.00917 10.1511 8.38194 10.9868 9.01101"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9863 13L12.9863 21M12.9863 13C12.2861 13 10.9779 14.9943 10.4863 15.5M12.9863 13C13.6866 13 14.9948 14.9943 15.4863 15.5"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconUploadV2;
